import axios from 'axios';
import { IResponse } from '~/services/api/types';
import { ICarePlanMedication } from './types';

const apiUrl = 'care-plan-medications';

export const getList = (patientId: number): IResponse<ICarePlanMedication[]> =>
  axios({
    method: 'get',
    url: `${apiUrl}/by-patient-id/${patientId}`,
  });

export const create = (
  patientId: number,
  data: ICarePlanMedication[],
): IResponse<ICarePlanMedication[]> =>
  axios({
    method: 'post',
    url: apiUrl,
    data,
    params: {
      patientId,
    },
  });

export const update = (data: ICarePlanMedication): IResponse<ICarePlanMedication> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export const remove = (id: number): IResponse<void> =>
  axios({
    method: 'delete',
    url: `${apiUrl}/${id}`,
  });
